<div class="main-container-wrapper">
    <div class="main-container">
        <div *ngIf="!isLoadingContract && !isLoadingContractState && !isLoadingContractItem">
            <!-- Title -->
            <div class="title-container">
                <!-- Return Button & Advertiser Info-->
                <div class="title-advertiser-info">
                    <div>
                        <button (click)="onReturnButtonClick()"
                                class="tv-round-icon-page-nav-button-light-blue-on-dark-bg">
                            <mat-icon class="arrow_back">arrow_back</mat-icon>
                        </button>
                    </div>
                    <div *ngIf="currentContract" class="div-sub-title">
                        <h1 class="advertiser-sub-title"> Groupe {{ currentContract.name }} :
                            Contrat {{ currentContract.id }}</h1>
                        <h4 class="advertiser-sub-title-2"> Année du contrat : {{ currentContractItem.year }}</h4>
                    </div>
                </div>
                <!---->

                <!-- Year -->
                <!--                <div class="states-div advertiser-sub-title">-->
                <!--                    {{currentContractItem?.year}}-->
                <!--                </div>-->

                <!-- States -->
                <!--                <div class="states-div" id="stateDropDown">-->
                <!--                    <button-->
                <!--                            class="states-select-button"-->
                <!--                            (click)="onShowDropDownButtonClick()"-->
                <!--                            [ngClass]="showDropDown ? 'active-states-select-button' : 'inactive-states-select-button'">-->
                <!--                        <mat-icon class="small-icon" matPrefix>circle</mat-icon>-->

                <!--                        <div *ngIf="!contractStates">-->
                <!--                            <mat-label class="label">Statut</mat-label>-->
                <!--                        </div>-->

                <!--                        <div *ngIf="currentContract">-->
                <!--                            <span class="label state-label">{{ selectedLabel }}</span>-->
                <!--                        </div>-->

                <!--                        <div>-->
                <!--                            <mat-icon class="align-icon">arrow_drop_down</mat-icon>-->
                <!--                        </div>-->
                <!--                    </button>-->
                <!--                    <div class="dropdown label" [ngClass]="showDropDown ? 'visible-dropdown' : 'invisible-dropdown'">-->
                <!--                        <div>-->
                <!--                            <mat-radio-group [(ngModel)]="selectedValue" (change)="onSelectStatesChange($event.value)">-->
                <!--                                <mat-radio-button *ngFor="let state of contractStates" [value]="state.id"-->
                <!--                                                  class="tv-ns-blue-checkbox">-->
                <!--                                    {{ state.name }}-->
                <!--                                </mat-radio-button>-->
                <!--                            </mat-radio-group>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>

            <!-- Information Générales -->
            <app-contract-general-informations
                    [contract]="currentContract"
                    [(contractItem)]="currentContractItem"
                    [checkSignedFn]="isSignedContractModifications.bind(this)"
            >
            </app-contract-general-informations>

            <!-- Engagement-->
            <app-contract-commitment
                    [commitmentList]="currentContractItem?.commitmentList?.commitments"
                    [commitmentCriteriaList]="currentContractItem?.commitmentList?.commitmentCriterias"
                    [contract]=currentContract
                    [contractItem]=currentContractItem
                    [checkSignedFn]="isSignedContractModifications.bind(this)"
            ></app-contract-commitment>

            <!-- Négociations Nationales -->
            <app-contract-natio-nego
                    [contract]="currentContract"
                    [contractItem]="currentContractItem"
                    [natioNegotiationList]="currentContractItem?.natioNegotiationList">
            </app-contract-natio-nego>

            <!-- CGRP ON -->
            <app-contract-cgrp-on
                    [contract]="currentContract"
                    [contractItem]="currentContractItem"
                    [natioNegotiationList]="currentContractItem?.natioNegotiationList">
            </app-contract-cgrp-on>

            <!-- CGRP OFF -->
            <app-contract-cgrp-off
                    [contract]="currentContract"
                    [contractItem]="currentContractItem"
                    [natioNegotiationList]="currentContractItem?.natioNegotiationList">
            </app-contract-cgrp-off>

            <!-- Négociations Thématiques -->
            <app-contract-thema-nego
                    [contract]="currentContract"
                    [contractItem]="currentContractItem"
                    [themaNegotiationList]="currentContractItem?.themaNegotiationList">
            </app-contract-thema-nego>

            <!-- Historiques des modifications -->
            <!--            <mat-expansion-panel [expanded]="1==0" class="light-flex-card">-->
            <!--                <mat-expansion-panel-header>-->
            <!--                    <mat-panel-title class="sub-title">-->
            <!--                        Historique des modification (@Aziz - sauvegarder contrat dans une table DateModif/JSON à-->
            <!--                        chaque modif)-->
            <!--                    </mat-panel-title>-->
            <!--                </mat-expansion-panel-header>-->
            <!--            </mat-expansion-panel>-->

            <!-- Commentaires -->
            <app-contract-comment></app-contract-comment>

            <ng-template #loading>
                <div class="spinner-container min-height-50">
                    <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
                </div>
            </ng-template>
        </div>
    </div>
</div>
